<template>
  <div class="plan-intro" v-title :data-title='"卓考网校|"+plan.name'>
    <main class="g-view-container">
      <h2 class="title">{{plan.name}}</h2>
      <img class="image" :src="plan.imgUrl" />
      <div class="content" v-html="plan.intro"></div>
      <a v-if="plan.start.isOpen" :href="plan.startUrl" class="btn-start">去执行</a>
    </main>
  </div>
</template>

<script>
  import planModel from 'models/plan';

  export default {
    name: 'Intro',
    data() {
      return {
        professionId: this.$route.params.professionId,
        planType: this.$route.params.planType,
      };
    },
    created() {
      this.plan = planModel.getPlan(this.professionId, this.planType);
    },
  };
</script>

<style lang="scss" scoped>
.plan-intro {
  border: 3px solid#2e92fe;
  border-radius: 8px;
  background-color: #fff;

  .title {
    margin-top: 20px;
    font-size: 18px;
    color: #333;
    font-weight: bold;
    text-align: center;
    line-height: 2;
  }

  .image {
    margin-top: 15px;
    width: 100%;
  }

  ::v-deep .content {
    padding: 0 15px;
    font-size: 12px;
    line-height: 2;

    p {
      margin: 10px 0;
      text-indent: 24px;
    }

    .title {
      margin: 40px 0 20px;
      padding: 8px 10px;
      text-indent: 0;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      background-color: #eee;
      border-radius: 5px;
    }

    .list {
      margin-left: 36px;
    }

    .red {
      color: red;
      font-weight: bold;
    }

    .blue {
      color: #00b0f0;
      font-weight: bold;
    }
  }

  .btn-start {
    position: absolute;
    right: 0;
    bottom: 50px;
    width: 80px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 30px;
    background-color: #fe585c;
    border-radius: 20px 0 0 20px;
  }
}
</style>
